import { render, staticRenderFns } from "./MortgagePage.vue?vue&type=template&id=3c31e6b2"
import script from "./MortgagePage.vue?vue&type=script&lang=js"
export * from "./MortgagePage.vue?vue&type=script&lang=js"
import style0 from "./MortgagePage.vue?vue&type=style&index=0&id=3c31e6b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports